import { render, staticRenderFns } from "./ApproveByTicketDetails.vue?vue&type=template&id=239e2f1d&scoped=true"
import script from "./ApproveByTicketDetails.vue?vue&type=script&lang=js"
export * from "./ApproveByTicketDetails.vue?vue&type=script&lang=js"
import style0 from "./ApproveByTicketDetails.vue?vue&type=style&index=0&id=239e2f1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239e2f1d",
  null
  
)

export default component.exports